import sanitizeHtml from "sanitize-html"

interface HubspotFormData {
  email: string
}

type Response = {
  status: "success" | "error"
  message: string
}

export const sendHubspotForm = ({
  email,
}: HubspotFormData): Promise<Response> => {
  // Hubspot config
  const portalId = "458431"
  const formGuid = "5c3ed10c-6f2c-4213-8e36-e8044636db89"
  const url = `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`

  const postBody = {
    fields: [
      {
        name: "email",
        value: email,
      },
    ],
    context: {
      pageUri: "www.pulsarplatform.com/new-normal",
      pageName: "The New Normal",
    },
  }

  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(postBody),
    redirect: "follow",
  })
    .then(res => res.json())
    .then(res => ({
      status: res && res.inlineMessage ? "success" : "error",
      message:
        res && res.inlineMessage
          ? sanitizeHtml(res.inlineMessage)
          : (res && res.errors && res.errors[0] && res.errors[0].message) ||
            "Something went wrong, please check input data and try again.",
    }))
}
